// extracted by mini-css-extract-plugin
export default {"dateWrapper":"sEXo1og","btnWrapper":"GklxcsM","label":"w1SkAHL","btn":"flT1_4x","calendarIcon":"KM3CBW4","actions":"E07Tl9A","cancelBtn":"InLanQI","applyBtn":"JSDENH8"};